import { FreightType } from "../../model/customer.model";
import { applyTaxAccordingFreight } from "./applyTaxAccordingFreight";

export function subtotalApplyTaxAccordingFreight(
  quantity: number,
  freightType: FreightType,
  unitPrice: number,
  freightUnitPrice: number
): number {
  const unit = applyTaxAccordingFreight(
    freightType,
    unitPrice,
    freightUnitPrice
  );
  return unit * quantity;
}
